import store from '@/store';
import i18n from '@/i18n';

export default function getAuthHeader(
  token?: string
): {
  Authorization: string;
  'X-Ekyc-Current-Language': string;
} {
  return {
    Authorization: `Bearer ${token || store.getters['auth/accessToken']}`,
    'X-Ekyc-Current-Language': i18n.locale
  };
}
